(function () {
  'use strict';

  var optionConfig = {
    wrapping: { on: 'Add Gift Wrapping', off: 'No Gift Wrapping', modal: '#giftCardsModal' },
    card: { on: 'Add Greeting Card', off: 'No Greeting Card', modal: '#giftWrappingModal' },
    message: { on: 'Add FREE Gift Message', off: 'No Gift Message' },
    video: { on: 'Add Video Greeting', off: 'No Video Greeting' },
    'hide-prices': { on: 'Hide Prices from Recipient', off: 'Show Prices' }
  };

  function normalise(value) {
    return (value || '').replace(/\s+/g, ' ').trim();
  }

  function dispatchInputEvents(element) {
    ['input', 'change', 'blur'].forEach(function (eventName) {
      element.dispatchEvent(new Event(eventName, { bubbles: true }));
    });
  }

  function getEngine() {
    return document.querySelector('.gpo-container');
  }

  function chooseGloboValue(value) {
    var engine = getEngine();
    if (!engine) return false;

    var control = Array.prototype.filter.call(engine.querySelectorAll('input[type="radio"][value]'), function (input) {
      return normalise(input.value) === value;
    })[0];
    if (!control || control.disabled) return false;
    if (control.checked) return true;

    // Globo binds its option logic to the radio input's change event. Clicking the
    // label or its nested text is unreliable because the app duplicates that text
    // in tooltips and option previews.
    control.click();
    return control.checked;
  }

  function findEngineTextInput(type) {
    var engine = getEngine();
    if (!engine) return null;
    var selector = type === 'card'
      ? 'textarea[data-field-name="Greeting Card Message"]'
      : 'input[data-field-name="Your Free Gift Message"]';
    return engine.querySelector(selector);
  }

  function relaxGloboMessageMinimum() {
    var engine = getEngine();
    if (!engine) return;
    var input = engine.querySelector('textarea[data-field-name="Greeting Card Message"]');
    if (!input) return;
    input.minLength = 0;
    input.removeAttribute('minlength');
    input.dataset.minlength = '0';
  }

  function setEngineText(type, value, attempt) {
    var input = findEngineTextInput(type);
    if (!input) {
      if ((attempt || 0) < 6) {
        window.setTimeout(function () {
          setEngineText(type, value, (attempt || 0) + 1);
        }, 100);
      }
      return false;
    }
    input.value = value;
    dispatchInputEvents(input);
    return true;
  }

  function setPanel(root, name, active) {
    var panel = root.querySelector('[data-gift-panel="' + name + '"]');
    if (!panel) return;
    panel.classList.toggle('is-open', active);
    panel.setAttribute('aria-hidden', active ? 'false' : 'true');
  }

  function resetVideoFeedback(root) {
    var actions = root.querySelector('[data-gift-video-actions]');
    var thanks = root.querySelector('[data-gift-video-thanks]');
    if (actions) actions.hidden = false;
    if (thanks) {
      thanks.hidden = true;
      thanks.textContent = '';
    }
  }

  function setVideoFeedback(root) {
    var actions = root.querySelector('[data-gift-video-actions]');
    var thanks = root.querySelector('[data-gift-video-thanks]');
    if (actions) actions.hidden = true;
    if (thanks) {
      thanks.textContent = "Video greeting added — you'll record it during checkout.";
      thanks.hidden = false;
    }

    document.dispatchEvent(new CustomEvent('ats:gift-video-added'));
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'video_greeting_added');
    }
  }

  function declineVideoGreeting(root) {
    clearGiftSelection(root, 'video');
    document.dispatchEvent(new CustomEvent('ats:gift-video-declined'));
    if (typeof window.gtag === 'function') {
      window.gtag('event', 'video_greeting_declined');
    }
  }

  function setSummary(root, type, value) {
    var item = root.querySelector('[data-gift-summary-item="' + type + '"]');
    if (!item) return;
    item.querySelector('span').textContent = value || '';
    item.hidden = !value;
    var summary = root.querySelector('[data-gift-summary]');
    summary.hidden = !root.querySelector('[data-gift-summary-item]:not([hidden])');
  }

  function openModal(selector) {
    if (!selector) return;
    var modal = document.querySelector(selector);
    if (!modal) return;
    if (window.jQuery && window.jQuery.fn.modal) {
      window.jQuery(modal).modal('show');
      return;
    }
    if (window.bootstrap && window.bootstrap.Modal) {
      window.bootstrap.Modal.getOrCreateInstance(modal).show();
    }
  }

  function setActionState(root, action, active) {
    var button = root.querySelector('[data-gift-action="' + action + '"]');
    if (!button) return;

    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');

    if (action === 'card' || action === 'message' || action === 'video') setPanel(root, action, active);
    if (action === 'video' && !active) resetVideoFeedback(root);
  }

  function clearGiftSelection(root, action) {
    var config = optionConfig[action];
    if (!config) return;
    chooseGloboValue(config.off);
    setActionState(root, action, false);
    if (action === 'wrapping' || action === 'card') setSummary(root, action, '');
    if (root.dataset.atsGiftPending === action) delete root.dataset.atsGiftPending;
  }

  function bindModalDismiss(root) {
    var modalToAction = {
      giftCardsModal: 'wrapping',
      giftWrappingModal: 'card'
    };

    Object.keys(modalToAction).forEach(function (modalId) {
      var modal = document.getElementById(modalId);
      if (!modal || modal.dataset.atsGiftDismissBound === 'true') return;
      modal.dataset.atsGiftDismissBound = 'true';

      var onDismiss = function () {
        var action = modalToAction[modalId];
        if (root.dataset.atsGiftPending === action) clearGiftSelection(root, action);
      };

      modal.addEventListener('hidden.bs.modal', onDismiss);
      if (window.jQuery) window.jQuery(modal).on('hidden.bs.modal.atsGiftOptions', onDismiss);
    });
  }

  function bindDecorativePropertiesFilter(root) {
    var form = root.closest('form[action="/cart/add"]');
    if (!form || form.dataset.atsGiftPropertiesFilterBound === 'true') return;
    form.dataset.atsGiftPropertiesFilterBound = 'true';

    form.addEventListener('formdata', function (event) {
      if (!event.formData) return;
      [
        'properties[Video Greeting]',
        'properties[Hide Prices from Recipient]'
      ].forEach(function (propertyName) {
        event.formData.delete(propertyName);
      });

      [
        { name: 'properties[Gift Wrapping]', value: 'No Gift Wrapping' },
        { name: 'properties[Greeting Card]', value: 'No Greeting Card' },
        { name: 'properties[Free Gift Message]', value: 'No Gift Message' }
      ].forEach(function (property) {
        if (event.formData.get(property.name) === property.value) {
          event.formData.delete(property.name);
        }
      });
    });
  }

  function prepareEngine() {
    var engine = getEngine();
    if (!engine) return;
    engine.classList.add('ats-gpo-engine');
    engine.setAttribute('aria-hidden', 'true');
  }

  function initialise(root) {
    prepareEngine();
    if (root.dataset.atsGiftOptionsReady === 'true') return;
    root.dataset.atsGiftOptionsReady = 'true';
    bindModalDismiss(root);
    bindDecorativePropertiesFilter(root);

    root.querySelectorAll('[data-gift-action]').forEach(function (button) {
      button.addEventListener('click', function () {
        var action = button.dataset.giftAction;
        var config = optionConfig[action];
        var active = !button.classList.contains('is-active');

        if (!chooseGloboValue(active ? config.on : config.off)) {
          console.warn('ATS Gift Options: Globo option was not found:', active ? config.on : config.off);
          return;
        }

        setActionState(root, action, active);

        if (action === 'card' || action === 'message') {
          if (action === 'card') {
            window.setTimeout(relaxGloboMessageMinimum, 0);
          }
          if (active) {
            window.setTimeout(function () {
              var input = root.querySelector('[data-gift-message="' + action + '"]');
              if (input) input.focus();
            }, 290);
          }
        }

        if (active && (action === 'wrapping' || action === 'card')) {
          root.dataset.atsGiftPending = action;
          openModal(config.modal);
        }

        if (!active && (action === 'wrapping' || action === 'card')) setSummary(root, action, '');
      });
    });

    root.querySelectorAll('[data-gift-message]').forEach(function (input) {
      input.addEventListener('input', function () {
        var type = input.dataset.giftMessage;
        var counter = root.querySelector('[data-gift-count="' + type + '"]');
        if (counter) counter.textContent = input.value.length;
        setEngineText(type, input.value);
      });
    });

    root.querySelectorAll('[data-gift-video-answer]').forEach(function (button) {
      button.addEventListener('click', function () {
        if (button.dataset.giftVideoAnswer === 'add') {
          setVideoFeedback(root);
          return;
        }
        declineVideoGreeting(root);
      });
    });

    document.addEventListener('ats:gift-addons:selected', function (event) {
      if (!event.detail) return;
      var type = event.detail.addonType;
      if (type === 'wrapping' || type === 'cards') {
        var action = type === 'cards' ? 'card' : 'wrapping';
        setActionState(root, action, true);
        if (root.dataset.atsGiftPending === action) delete root.dataset.atsGiftPending;
        setSummary(root, action, event.detail.optionLabel);
      }
    });
  }

  function boot() {
    document.querySelectorAll('[data-ats-gift-options]').forEach(initialise);
  }

  document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', function () {
    boot();
    window.setTimeout(boot, 800);
  });
}());
